import classNames from 'classnames/bind';
import * as styles from './CategoryDeals.css';

const cx = classNames.bind(styles);

// CSS classes for categoryDeals written here
export const categoryDealsTheme = {
    styleATheme: styles.styleATheme,
    styleA4Cat: cx('styleATheme', 'styleA4CatTheme'),
    styleA6Cat: cx('styleATheme', 'styleA6CatTheme'),
    styleA8Cat: cx('styleATheme', 'styleA8CatTheme'),
    styleBTheme: styles.styleBTheme,
    styleCTheme: styles.styleCTheme,
    container: styles.container,
    containerTitle: styles.containerTitle,
    container1: styles.container1,
    container2: styles.container2,
    contentBlock: styles.contentBlock,
    headerBlock: styles.headerBlock,
    footerBlock: styles.footerBlock,
    categoryTitle: styles.title,
    categorySubTitle: styles.subTitle,
    styleABtn: styles.styleABtn,
    styleBHeaderLink: styles.styleBHeaderLink,
    headlineAboveClass: styles.headlineAboveClass,
    mainTitle: styles.mainTitle,
    subTitle: styles.subTitle,
    editInfoLink: styles.editInfoLink,
};

// VisNav style Theme
export const visNavThemes = {
    styleA: 'styleA',
    styleA4Cat: 'styleA',
    styleA6Cat: 'styleA6cat',
    styleA8Cat: 'styleA8cat',
    styleB: 'styleB',
    styleC: 'styleC',
};

// editorialTypes style Theme
export const editorialTypes = {
    editorialDealStyleA: 'editorialDealStyleA',
    editorialDealStyleA6Cat: 'editorialDealStyleA6cat',
    editorialDealStyleA8Cat: 'editorialDealStyleA8cat',
    editorialDealStyleB: 'editorialDealStyleB',
    editorialDealStyleC: 'editorialDealStyleC',
    // editorialDealStyleAtitleOut: 'test',
};

export const ctaPositionConst = {
    top: 'cta-top',
    middle: 'cta-middle',
    bottom: 'headline-within',
};
